import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Recipes
export const getRecipes = (search = '', mealType = null) => {
  const params = { search };
  if (mealType) {
    params.meal_type = mealType;
  }
  return api.get('/api/recipes/', { params });
};

export const getRecipe = (id) => {
  return api.get(`/api/recipes/${id}`);
};

export const createRecipe = (recipe) => {
  return api.post('/api/recipes/', recipe);
};

export const updateRecipe = (id, recipe) => {
  return api.put(`/api/recipes/${id}`, recipe);
};

export const deleteRecipe = (id) => {
  return api.delete(`/api/recipes/${id}`);
};

export const createRecipesBatch = (recipes) => {
  return api.post('/api/recipes/batch', { recipes });
};

// Meal Plans
export const getWeekMealPlan = (startDate) => {
  return api.get(`/api/meal-plans/week/${startDate}`);
};

export const getDayMealPlan = (date) => {
  return api.get(`/api/meal-plans/day/${date}`);
};

export const createMealPlanItem = (item) => {
  return api.post('/api/meal-plans/', item);
};

export const deleteMealPlanItem = (id) => {
  return api.delete(`/api/meal-plans/${id}`);
};

export const getMonthStatus = (year, month) => {
  return api.get(`/api/meal-plans/month/${year}/${month}`);
};

